<div class="container-fluid business-page">
    <nav class="context-breadcrumb" aria-label="breadcrumb rounded">
        <ol class="breadcrumb shadow-lg">
            <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/compte/professionel">Comptes business utilisateurs</a></li>
            <li class="breadcrumb-item active" aria-current="page">Informations du compte business</li>
        </ol>
    </nav>

    <div class="card border-0 business-shell">
        <div class="card-header text-white text-center generalbgColorV2">
            Compte affaire
            <span *ngIf="selectedBusiness" class="d-block business-subtitle">{{ selectedBusiness.nomEntreprise }}</span>
        </div>

        <div class="card-body">
            <div class="alert alert-info mb-3" *ngIf="loadingAccounts">
                Chargement des comptes business...
            </div>

            <div class="alert alert-info mb-0" *ngIf="!loadingAccounts && !baccountList.length">
                Aucun compte affaire disponible pour cet utilisateur.
            </div>

            <ng-container *ngIf="!loadingAccounts && baccountList.length">
                <div class="row account-toolbar">
                    <div class="col-sm-12 col-md-7 col-lg-6 mb-2">
                        <label class="tool-label" for="selectedBusiness">Compte business</label>
                        <select id="selectedBusiness" class="form-control" [value]="selectedBusinessId ?? ''"
                            (change)="selectBusinessAccount(+$any($event.target).value)">
                            <option *ngFor="let b of baccountList" [value]="b.id">
                                {{ b.nomEntreprise }} - {{ getAccountNumberDisplay(b.accountNumber) }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-12 col-md-5 col-lg-6 mb-2 d-flex align-items-end">
                        <div class="account-counter">
                            <span class="counter-chip">{{ baccountList.length }} compte(s) business</span>
                        </div>
                    </div>
                </div>

                <div class="card border-0 business-overview mb-3" *ngIf="selectedBusiness as b">
                    <div class="card-body">
                        <div class="overview-grid">
                            <div class="overview-item">
                                <span class="overview-label">Numero de compte</span>
                                <strong class="overview-value">{{ getAccountNumberDisplay(b.accountNumber) }}</strong>
                            </div>
                            <div class="overview-item">
                                <span class="overview-label">Solde</span>
                                <strong class="overview-value">{{ b.accountBalance | currency:(b.sigleMonnaie || 'XAF')
                                    }}</strong>
                            </div>
                            <div class="overview-item">
                                <span class="overview-label">Gestionnaire</span>
                                <strong class="overview-value">{{ b.nomGestionnaire }} {{ b.prenomGestionaire
                                    }}</strong>
                            </div>
                            <div class="overview-item">
                                <span class="overview-label">Raison sociale</span>
                                <strong class="overview-value">{{ b.nomEntreprise }}</strong>
                            </div>
                            <div class="overview-item">
                                <span class="overview-label">Numero IU</span>
                                <strong class="overview-value">{{ b.numero || '-' }}</strong>
                            </div>
                            <div class="overview-item">
                                <span class="overview-label">Statut</span>
                                <strong class="overview-value">
                                    <span class="status-dot" [class.ok]="b.actif"></span>
                                    {{ b.actif ? 'Verifie' : 'Non verifie' }}
                                </strong>
                            </div>
                        </div>

                        <div class="overview-actions">
                            <button *ngIf="b.actif && b.enable; else showActiver" type="button"
                                class="btn btn-outline-danger btn-sm" (click)="desactiverBaccount(b.id)">
                                Desactiver le compte
                            </button>
                            <ng-template #showActiver>
                                <button type="button" class="btn btn-outline-success btn-sm"
                                    (click)="activerBaccount(b.id)">
                                    Activer le compte
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="alert alert-info mb-3" *ngIf="loadingBusinessLists">
                    Chargement des donnees du compte business...
                </div>
                <div class="alert alert-danger mb-3" *ngIf="!loadingBusinessLists && listError">
                    {{ listError }}
                </div>

                <ng-container *ngIf="selectedBusinessId != null">
                    <section class="tab-panel account-panel mb-3" *ngIf="selectedBusiness as b">
                        <div class="row">
                            <div class="col-sm-12 col-lg-5 mb-3 mb-lg-0">
                                <div class="card list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        Informations compte</div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Entreprise</span>
                                            <strong class="list-data-value">{{ b.nomEntreprise }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Gestionnaire</span>
                                            <strong class="list-data-value">{{ b.nomGestionnaire }} {{
                                                b.prenomGestionaire }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Numero</span>
                                            <strong class="list-data-value">{{ getAccountNumberDisplay(b.accountNumber)
                                                }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Solde actuel</span>
                                            <strong class="list-data-value">{{ b.accountBalance |
                                                currency:(b.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-lg-7">
                                <div class="card list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        Resume activite</div>
                                    <div class="card-body summary-grid">
                                        <div class="summary-item">
                                            <span class="summary-value">{{ caissierlist.length }}</span>
                                            <span class="summary-label">Caissiers</span>
                                        </div>
                                        <div class="summary-item">
                                            <span class="summary-value">{{ achatlist.length }}</span>
                                            <span class="summary-label">Achats</span>
                                        </div>
                                        <div class="summary-item">
                                            <span class="summary-value">{{ depotlist.length }}</span>
                                            <span class="summary-label">Depots</span>
                                        </div>
                                        <div class="summary-item">
                                            <span class="summary-value">{{ retraitlist.length }}</span>
                                            <span class="summary-label">Retraits</span>
                                        </div>
                                        <div class="summary-item">
                                            <span class="summary-value">{{ codeList.length }}</span>
                                            <span class="summary-label">Codes retrait</span>
                                        </div>
                                        <!--<div class="summary-item">
                                            <span class="summary-value">{{ mensualiteList.length }}</span>
                                            <span class="summary-label">Mensualites</span>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <nav class="tabs-shell" aria-label="Navigation compte business">
                        <div class="smart-tabs" role="tablist">
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'caissier'"
                                (click)="setActiveTab('caissier')">
                                Caissiers
                                <span class="tab-count" *ngIf="caissierlist.length">{{ caissierlist.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'achats'"
                                (click)="setActiveTab('achats')">
                                Achats
                                <span class="tab-count" *ngIf="achatlist.length">{{ achatlist.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'depots'"
                                (click)="setActiveTab('depots')">
                                Depots
                                <span class="tab-count" *ngIf="depotlist.length">{{ depotlist.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'retraits'"
                                (click)="setActiveTab('retraits')">
                                Retraits
                                <span class="tab-count" *ngIf="retraitlist.length">{{ retraitlist.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'codes'"
                                (click)="setActiveTab('codes')">
                                Codes
                                <span class="tab-count" *ngIf="codeList.length">{{ codeList.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'mensualites'"
                                (click)="setActiveTab('mensualites')">
                                Mensualites
                                <span class="tab-count" *ngIf="mensualiteList.length">{{ mensualiteList.length }}</span>
                            </button>
                            <button type="button" class="smart-tab-btn" [class.active]="activeTab === 'tarif'"
                                (click)="setActiveTab('tarif')">
                                Tarif
                            </button>
                        </div>
                    </nav>

                    <section class="tab-panel" *ngIf="activeTab === 'caissier'">
                        <div class="row" *ngIf="caissierlist.length; else emptyCaissiers">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let c of caissierlist">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        {{ c.firstName }} {{ c.lastName }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Identifiant</span>
                                            <strong class="list-data-value">{{ c.username || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Telephone</span>
                                            <strong class="list-data-value">{{ c.phone || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Email</span>
                                            <strong class="list-data-value">{{ c.email || '-' }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyCaissiers>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('caissier') }}
                            </div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'achats'">
                        <div class="row period-filter-row mb-3" *ngIf="achatlist.length">
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Mois</label>
                                <select class="form-control form-control-sm" [value]="selectedAchatsMonth ?? ''"
                                    (change)="selectedAchatsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Tous les mois</option>
                                    <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Annee</label>
                                <select class="form-control form-control-sm" [value]="selectedAchatsYear ?? ''"
                                    (change)="selectedAchatsYear = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Toutes les annees</option>
                                    <option *ngFor="let year of achatsYearOptions" [value]="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 d-flex align-items-end mt-2 mt-md-0">
                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                    (click)="resetPeriodFilter('achats')">
                                    reinitialiser
                                </button>
                            </div>
                        </div>

                        <div class="row" *ngIf="filteredAchatsList.length; else emptyAchats">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let a of filteredAchatsList">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        {{ a.dateAchat | date:'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Caissier</span>
                                            <strong class="list-data-value">{{ a.caissier || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Montant</span>
                                            <strong class="list-data-value">{{ a.montan | currency:(a.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyAchats>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('achats') }}
                            </div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'depots'">
                        <div class="row period-filter-row mb-3" *ngIf="depotlist.length">
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Mois</label>
                                <select class="form-control form-control-sm" [value]="selectedDepotsMonth ?? ''"
                                    (change)="selectedDepotsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Tous les mois</option>
                                    <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Annee</label>
                                <select class="form-control form-control-sm" [value]="selectedDepotsYear ?? ''"
                                    (change)="selectedDepotsYear = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Toutes les annees</option>
                                    <option *ngFor="let year of depotsYearOptions" [value]="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 d-flex align-items-end mt-2 mt-md-0">
                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                    (click)="resetPeriodFilter('depots')">
                                    reinitialiser
                                </button>
                            </div>
                        </div>

                        <div class="row" *ngIf="filteredDepotsList.length; else emptyDepots">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let d of filteredDepotsList">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        {{ d.date | date:'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Caissier</span>
                                            <strong class="list-data-value">{{ d.caissier || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Montant</span>
                                            <strong class="list-data-value">{{ d.montan | currency:(d.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Retenu</span>
                                            <strong class="list-data-value">{{ d.retenu | currency:(d.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Depot reel</span>
                                            <strong class="list-data-value">{{ d.depot | currency:(d.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyDepots>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('depots') }}
                            </div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'retraits'">
                        <div class="row period-filter-row mb-3" *ngIf="retraitlist.length">
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Mois</label>
                                <select class="form-control form-control-sm" [value]="selectedRetraitsMonth ?? ''"
                                    (change)="selectedRetraitsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Tous les mois</option>
                                    <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Annee</label>
                                <select class="form-control form-control-sm" [value]="selectedRetraitsYear ?? ''"
                                    (change)="selectedRetraitsYear = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Toutes les annees</option>
                                    <option *ngFor="let year of retraitsYearOptions" [value]="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 d-flex align-items-end mt-2 mt-md-0">
                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                    (click)="resetPeriodFilter('retraits')">
                                    reinitialiser
                                </button>
                            </div>
                        </div>

                        <div class="row" *ngIf="filteredRetraitsList.length; else emptyRetraits">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let r of filteredRetraitsList">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        {{ r.date | date:'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Caissier</span>
                                            <strong class="list-data-value">{{ r.caissier || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Montant voulu</span>
                                            <strong class="list-data-value">{{ r.montan | currency:(r.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Retenu</span>
                                            <strong class="list-data-value">{{ r.retenu | currency:(r.sigleMonnaie ||
                                                selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Retrait total</span>
                                            <strong class="list-data-value list-data-total">{{ r.retrait |
                                                currency:(r.sigleMonnaie || selectedBusiness?.sigleMonnaie || 'XAF')
                                                }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyRetraits>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('retraits') }}
                            </div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'codes'">
                        <div class="row" *ngIf="codeList.length; else emptyCodes">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let code of codeList">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        {{ code.createdOn | date:'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Code</span>
                                            <strong class="list-data-value">{{ code.pinNumber || '-' }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Utilise le</span>
                                            <strong class="list-data-value">{{ code.usedOn ? (code.usedOn |
                                                date:'dd/MM/yyyy HH:mm:ss') : 'Non utilise' }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyCodes>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('codes') }}
                            </div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'mensualites'">
                        <div class="row period-filter-row mb-3" *ngIf="mensualiteList.length">
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Mois</label>
                                <select class="form-control form-control-sm" [value]="selectedMensualitesMonth ?? ''"
                                    (change)="selectedMensualitesMonth = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Tous les mois</option>
                                    <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="filter-label">Annee</label>
                                <select class="form-control form-control-sm" [value]="selectedMensualitesYear ?? ''"
                                    (change)="selectedMensualitesYear = $any($event.target).value ? +$any($event.target).value : null">
                                    <option value="">Toutes les annees</option>
                                    <option *ngFor="let year of mensualitesYearOptions" [value]="year">{{ year }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 d-flex align-items-end mt-2 mt-md-0">
                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                    (click)="resetPeriodFilter('mensualites')">
                                    reinitialiser
                                </button>
                            </div>
                        </div>

                        <div class="row" *ngIf="filteredMensualitesList.length; else emptyMensualites">
                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3" *ngFor="let m of filteredMensualitesList">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        Mois {{ m.month }}/{{ m.annee }}
                                    </div>
                                    <div class="card-body list-data-body">
                                        <div class="list-data-row">
                                            <span class="list-data-label">Achats</span>
                                            <strong class="list-data-value">{{ m.achat |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Depots</span>
                                            <strong class="list-data-value">{{ m.depot |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">B. depots</span>
                                            <strong class="list-data-value">{{ m.bDepot |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">Retraits</span>
                                            <strong class="list-data-value">{{ m.retrait |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <div class="list-data-row">
                                            <span class="list-data-label">B. retraits</span>
                                            <strong class="list-data-value">{{ m.bRetrait |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>
                                        <!--<div class="list-data-row">
                                            <span class="list-data-label">Solde mensuel</span>
                                            <strong class="list-data-value list-data-total">{{ m.soldeMensuel |
                                                currency:(selectedBusiness?.sigleMonnaie || 'XAF') }}</strong>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyMensualites>
                            <div class="alert alert-info empty-list-message mb-0">{{ getEmptyListMessage('mensualites')
                                }}</div>
                        </ng-template>
                    </section>

                    <section class="tab-panel" *ngIf="activeTab === 'tarif'">
                        <div class="row">
                            <div class="col-sm-12 col-lg-5 mb-3">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        Tarification</div>
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group">
                                                <label for="tarification" class="filter-label">Type de tarif</label>
                                                <select class="form-control" id="tarification">
                                                    <option value=""></option>
                                                    <option value="1">au click</option>
                                                    <option value="2">au mois</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label for="prix" class="filter-label">Montant</label>
                                                <input type="number" class="form-control" id="prix" />
                                            </div>
                                            <button type="button" class="btn btn-primary btn-sm">Enregistrer</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-lg-7 mb-3">
                                <div class="card border-0 list-data-card h-100">
                                    <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                        Statut</div>
                                    <div class="card-body d-flex align-items-center">
                                        <p class="mb-0 text-muted">
                                            Cette section est prete pour la configuration tarifaire du compte business
                                            selectionne.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
